import { createSelector } from "reselect"
import { StateWithStatus, Status } from "../reducers"

const statusSelector = (state: StateWithStatus | undefined) => state?.status

export const isLoading = createSelector(
  statusSelector,
  (status: Status) => status === Status.PENDING
)
